import { Slot } from '../../Model/Slot';
import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';

export interface GetAllSlotsResponse {
  slots: Slot[];
  total_count: number;
}

export class GetAllSlotsUseCase {
  constructor(private repo: SlotRepository) {}

  execute(me: User, active?: boolean): Promise<GetAllSlotsResponse> {
    return this.repo.getAllSlots(me, active);
  }
} 